import React, { useRef, useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ICON_SAVE, ICON_CANCEL } from '../../extras/icons';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveOfijusAction, updateOfijusAction } from '../../../actions/ofijusActions';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
import ButtonSpinner from '../../layout/ButtonSpinner';
//Función principal
const OfijuForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refNombre = useRef();
    //Datos iniciales
    const initialData = {
        nombre: '',
        direccion: '',
        localidad: '',
        telefono: '',
        telefonoAlt: '',
        email: '',
        emailAgenda: '',
        observaciones: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const ofijusLoading = useSelector( state => state.ofijus.loadingSave );
    const errorSave = useSelector( state => state.ofijus.errorSave );
    const isEdit = useSelector( state => state.ofijus.isEdit );
    const ofijuSelected = useSelector( state => state.ofijus.ofijuSelected );
    //Inicializo el state local
    const [ ofiju, setOfiju ] = useState(initialData);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && ofijuSelected){
            setOfiju(ofijuSelected);
        }else{
            setOfiju(initialData);
        }
    }, [isEdit, ofijuSelected, show])
    //Manejo de cambios
    const handleChange = e => {
        setOfiju({
            ...ofiju,
            [e.target.name]: e.target.value
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Inicializo los datos
        let data = {
            ...ofiju,
            activo: 1
        }
        //Agrego los nuevos valores
        data = {
            ...data,
            ...values
        }
        //Verifico si es edición o alta
        if(ofiju.id){
            //Es edición
            dispatch( updateOfijusAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveOfijusAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Pongo el foco en el primer campo
        refNombre.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setOfiju(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        nombre: yup.string().required(),
        direccion: yup.string().nullable(),
        localidad: yup.string().nullable(),
        telefono: yup.string().nullable(),
        telefonoAlt: yup.string().nullable(),
        email: yup.string().email().nullable(),
        emailAgenda: yup.string().email().nullable(),
        observaciones: yup.string().nullable()
    });
    //Renderizo
    return (
        <Modal 
            show={show} 
            onHide={handleCloseForm} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Ofiju&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...ofiju }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-12">
                                    <label htmlFor="nombre">Nombre</label>
                                    <Form.Control
                                        id="nombre"
                                        className="form-control" 
                                        autoFocus 
                                        name="nombre" 
                                        type="text" 
                                        value={ values.nombre }
                                        onChange={handleChange}
                                        ref={refNombre}
                                        isInvalid={!!errors.nombre}
                                        disabled={ ofijusLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.nombre }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-8">
                                    <label htmlFor="direccion">Dirección</label>
                                    <Form.Control
                                        id="direccion"
                                        className="form-control" 
                                        name="direccion" 
                                        type="text" 
                                        value={ values.direccion }
                                        onChange={handleChange}
                                        isInvalid={!!errors.direccion}
                                        disabled={ ofijusLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.direccion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <label htmlFor="localidad">Localidad</label>
                                    <Form.Control
                                        id="localidad"
                                        className="form-control" 
                                        name="localidad" 
                                        type="text" 
                                        value={ values.localidad }
                                        onChange={handleChange}
                                        isInvalid={!!errors.localidad}
                                        disabled={ ofijusLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.localidad }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="telefono">Teléfono</label>
                                    <Form.Control
                                        id="telefono"
                                        className="form-control" 
                                        name="telefono" 
                                        type="text" 
                                        value={ values.telefono }
                                        onChange={handleChange}
                                        isInvalid={!!errors.telefono}
                                        disabled={ ofijusLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.telefono }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="telefonoAlt">Teléfono Alt.</label>
                                    <Form.Control
                                        id="telefonoAlt"
                                        className="form-control" 
                                        name="telefonoAlt" 
                                        type="text" 
                                        value={ values.telefonoAlt }
                                        onChange={handleChange}
                                        isInvalid={!!errors.telefonoAlt}
                                        disabled={ ofijusLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.telefonoAlt }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="email">Email</label>
                                    <Form.Control
                                        id="email"
                                        className="form-control" 
                                        name="email" 
                                        type="text" 
                                        value={ values.email }
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                        disabled={ ofijusLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.email }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="emailAgenda">Email Agenda</label>
                                    <Form.Control
                                        id="emailAgenda"
                                        className="form-control" 
                                        name="emailAgenda" 
                                        type="text" 
                                        value={ values.emailAgenda }
                                        onChange={handleChange}
                                        isInvalid={!!errors.emailAgenda}
                                        disabled={ ofijusLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.emailAgenda }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="observaciones">Observaciones</label>
                                    <Form.Control
                                        id="observaciones"
                                        className="form-control" 
                                        name="observaciones" 
                                        type="text" 
                                        value={ values.observaciones }
                                        onChange={handleChange}
                                        isInvalid={!!errors.observaciones}
                                        disabled={ ofijusLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.observaciones }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                ofijusLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ ofijusLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ ofijusLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default OfijuForm;